import { FC, PropsWithChildren, ReactNode } from "react";
import Head from "next/head";
import { Header } from "../header";
import { Footer } from "../footer";

interface ArticleProps extends PropsWithChildren {
  title?: string;
  description?: string;
  children: ReactNode;
}

export const Article: FC<ArticleProps> = ({ title, description, children }) => {
  return (
    <>
      <Head>
        <title>{title ?? "Jooalan"}</title>
        <meta name="description" content={description ?? "Jooalan"} />
      </Head>
      <main className="flex flex-col items-center justify-center">
        <Header />
        <section className="w-full max-w-[960px] py-8 px-4 lg:px-8">
          {children}
        </section>
        <Footer />
      </main>
    </>
  );
};
